import { must } from "@/common/utils/must";
import ApplicationData from "@/modules/ApplicationData";
import { valueNames } from "@/modules/Constants";
import ExperienceData from "@/modules/ExperienceData";
import ExperienceMetadata from "@/modules/ExperienceMetadata";
import FavoritesData from "@/modules/FavoritesData";
import * as orientationLandscape from "@/modules/orientationLandscape";
import * as orientationPortrait from "@/modules/orientationPortrait";
import * as pluginManager from "@/plugin/pluginManager";
import { createStore } from "@/stores/createStore";
import {
  experienceDataStatus,
  type ExperienceModel,
} from "@/stores/experience/types";

function createModel(): ExperienceModel {
  const pixmoto = must(window.pixmoto, "window.pixmoto");
  const experienceMetadata = new ExperienceMetadata(pixmoto.experienceMetadata);
  const shell =
    window.pixmoto?.experienceMetadata &&
    window.pixmoto.experienceMetadata.idexperience != null
      ? { idexperience: window.pixmoto.experienceMetadata.idexperience }
      : {};
  const experienceData = new ExperienceData(experienceMetadata, shell);
  const favoritesData = new FavoritesData(experienceData);
  const applicationData = new ApplicationData();
  return {
    experienceData,
    favoritesData,
    applicationData,
    status: experienceDataStatus.UNKNOWN,
    template: applicationData.isPortrait()
      ? orientationPortrait
      : orientationLandscape,
    error: null,
    plugin: pluginManager,
  };
}

const model = createModel();
model.plugin.configure(model);

export const experienceStore = createStore(model);

/** Shows the control bar and the panel on the template as the application values say. */
export function updateTemplateData(state: ExperienceModel) {
  if (state.template) {
    state.template.setShowControlBar(
      state.applicationData.getValue(
        valueNames.HAS_CONTROL_BAR,
        false,
      ) as boolean,
    );
    state.template.setShowPanel(state.applicationData.showShopWindow());
  }
}
